import type { PageProps } from '@apps/card/routes/CardCustomizer/components/Page';
import { Page } from '@apps/card/routes/CardCustomizer/components/Page';
import { PageScaler } from '@apps/card/routes/CardCustomizer/components/PageScaler';
import { usePointerUnitPosition } from '@apps/card/routes/CardCustomizer/components/usePointerUnitPosition';
import { PAPER_TEXTURE_URL } from '@shared/components/GiftWrap/Reveal/premiumEnvelope.styles';
import { StationeryDraftFormat } from '@graphql/generated-base';
import { Box } from '@withjoy/joykit';
import React from 'react';

interface InteractiveCardProps extends Pick<PageProps, 'width' | 'height' | 'page' | 'shape' | 'format' | 'cssVarStyle' | 'forcePlaceholderQRCode'> {
  interactive?: boolean;
}

export const InteractiveCard: React.FC<InteractiveCardProps> = props => {
  const { width, height, page, shape, interactive = true, cssVarStyle, forcePlaceholderQRCode } = props;
  const { unitPosition, elementRef } = usePointerUnitPosition();
  const { x, y } = interactive ? unitPosition : { x: 0, y: 0 };

  return (
    <Box
      ref={elementRef}
      style={{
        width,
        height,
        transform: `perspective(504px) rotateX( ${-y * 2}deg) rotateY(${x * 2}deg)`,
        filter: `drop-shadow(${-x * 20 - 10}px ${-y * 20 + 15}px  15px rgba(0,0, 0, 0.35))`,
      }}
    >
      <PageScaler>
        <Page
          width={5}
          height={7}
          page={page}
          shape={shape}
          format={StationeryDraftFormat.digital}
          cssVarStyle={cssVarStyle}
          forcePlaceholderQRCode={forcePlaceholderQRCode}
          texture={
            interactive
              ? `
                url(${PAPER_TEXTURE_URL}),
                radial-gradient(
                  ellipse at ${(1 - (x + 0.5)) * 100}% ${(1 - (y + 0.5)) * 100}%,
                  hsla(0, 0%, 100%, 0.2),
                  hsla(0, 0%, 100%, 0.0)
                )
              `
              : undefined
          }
        />
      </PageScaler>
    </Box>
  );
};
